import { useEffect } from "react";
import Radio from "backbone.radio";
import strings from "common/strings";
import { ThemeProvider } from "styled-components";
import { Provider, shallowEqual, useSelector } from "react-redux";

import { usePolling } from "common/hooks";
import { FETCH_DOWNLOADS } from "common/actions/downloads";
import { ensureErrorCallback } from "common/components/error";
import { AuthRoute, useRouteMatch, useParams } from "extensions/react-router";
import { store } from "common/store";
import { theme } from "common/themes/styled";

import { ExportDialog } from "./exportDialog/exportDialog";

const fetch_downloads_notifications = () => store.dispatch(FETCH_DOWNLOADS());
function DownloadsPolling() {
    const merchant_config = useSelector((state) => state.common.merchant_config, shallowEqual);
    usePolling({
        fetch: fetch_downloads_notifications,
        when: !!merchant_config._id
    });
    
    return null;
}

export function DownloadsRouter() {
    const { url } = useRouteMatch();
    
    return (
        <>
            {/* The Export dialog should render regardless of whether or not the route matches. */}
            <ThemeProvider theme={theme}>
                <Provider store={store}>
                    <ExportDialog />
                </Provider>
            </ThemeProvider>
            <DownloadsPolling/>
            <AuthRoute path={[`${url}/downloads/:id?`, `${url}/administrator/downloads/:id?`]} component={DownloadsComponent} />
        </>
    );
}

function DownloadsComponent() {
    const { id } = useParams();

    useEffect(() => {
        async function main() {
            try {
                const { DownloadsPage } = await import("./downloadsPage");

                Radio.channel("main").request("show:app:view", <DownloadsPage downloadId={id} />, {
                    hideDatePicker: true,
                    waitForAttach: true,
                    name: strings.page_downloads
                });
            } catch (error) {
                ensureErrorCallback(error);
            }
        }
        main();
    }, [id]);

    return null;
}
